<div class="notice">
    @if (text) {
    <div class="flex-container-space-between">
        <span class="heading">
            @if (texts) {
            <mat-icon class="icon">{{ icon }}</mat-icon>
            <h4>{{ text }}</h4>
            } @else {
            <mat-icon style="overflow: initial;" class="icon">{{ icon }}</mat-icon>
            <span>{{ text }}</span>
            }
        </span>
    </div>
    }
    @if (texts) {
    <div class="list-container">
        <ul>
            @for (text of texts; track text) {
            <li [innerHTML]="text"></li>
            }
        </ul>
    </div>
    }
</div>